import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

import Config from '../../constants/appConfig';
import MaterialIcon from './../../components/MaterialIcon';
import { notification } from 'antd';

import { useParams } from "react-router";

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import tools from '../../components/util/tools';

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import DeleteIcon from '@material-ui/icons/Delete';

import MaskedInput from 'react-text-mask';

import Units from '../../components/util/units';
const TIMEZONES = [
  'America/Sao_Paulo',
  'America/Manaus',
  'America/Rio_Branco',
  'America/Cuiaba',
  'America/Campo_Grande',
  'America/Porto_Velho',
  'America/Boa_Vista',
  'America/Noronha',
  'America/Argentina/Buenos_Aires',
  'America/Asuncion',
  'America/Bogota',
  'America/Caracas',
  'America/La_Paz',
  'America/Lima',
  'America/Montevideo',
  'America/Santiago',
  'America/Mexico_City',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'UTC',
  'Europe/Lisbon',
  'Europe/London',
  'Europe/Madrid',
  'Europe/Paris',
  'Africa/Johannesburg',
  'Asia/Dubai',
  'Asia/Tokyo',
  'Australia/Sydney'
];

const getTimezoneOffsetLabel = timezone => {
  try {
    const timezoneName = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'shortOffset'
    }).formatToParts(new Date()).find(part => part.type === 'timeZoneName').value;

    if (timezoneName === 'GMT') {
      return 'UTC+0';
    }

    const offset = timezoneName.match(/^GMT([+-])0?(\d{1,2})(?::(\d{2}))?$/);
    if (!offset) {
      return timezoneName;
    }

    return `UTC${offset[1]}${Number(offset[2])}${offset[3] && offset[3] !== '00' ? `:${offset[3]}` : ''}`;
  } catch (error) {
    try {
      const now = new Date();
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }).formatToParts(now).reduce((values, part) => {
        values[part.type] = part.value;
        return values;
      }, {});

      const timeInTimezone = Date.UTC(
        Number(parts.year),
        Number(parts.month) - 1,
        Number(parts.day),
        Number(parts.hour),
        Number(parts.minute),
        Number(parts.second)
      );
      const offsetMinutes = Math.round((timeInTimezone - now.getTime()) / 60000);
      const absoluteOffset = Math.abs(offsetMinutes);
      const hours = Math.floor(absoluteOffset / 60);
      const minutes = absoluteOffset % 60;

      return `UTC${offsetMinutes >= 0 ? '+' : '-'}${hours}${minutes ? `:${String(minutes).padStart(2, '0')}` : ''}`;
    } catch (fallbackError) {
      return '';
    }
  }
};

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  }
});

class Edit extends React.Component {

  cid = this.props.id;

  state = {
    name: '',
    nick_name: '',
    registrationNumber: '',
    fone: '',
    fones: [],
    managementPhoneNumbers: [],
    email: '',
    contatc_name: '',
    cep: '',
    uf: '',
    localidade: '',
    bairro: '',
    logradouro: '',
    numero: '',
    complemento: '',
    country: 'Brasil',
    timezone: 'America/Sao_Paulo',
    obs: '',
    image: '',
    imagehaschanged: false,
    tipo_pessoa: 'J',
    cnpj: '',
    cpf: '',
    id: this.cid,
    limit_orc_ha: 0,
    limit_apr_ha: 0,
    limit_play_ha: 0,
    limit_als_ha: 0,
    limit_json_ha: 0,
    limit_kmz_ha: 0,
    limit_clima_api: 0,
    storage_size: 0,
    limit: 0,
    openTask: false,
    type: '',
    itensTask: [],
    url: '',
    method: 'POST',
    header_tag: '',
    key_value: '',
    dailySummary: false,
    openModules: false,
    realTime3D: false,
    realTime3DJobStartAlert: false,
    speed_unit: '',
    volume_unit: '',
    length_unit: '',
    area_unit: '',
  };


  componentDidMount() {
    if (this.state.id) {
      const apiUrl = Config.server + '/company/' + this.state.id;//TODO: arrumar!!!

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            if (result.length > 0) {
              if (!result[0].cnpj || result[0].cnpj.length > 16) {
                this.setState({ cnpj: result[0].cnpj, tipo_pessoa: 'J' });
              } else {
                this.setState({ cpf: result[0].cnpj, tipo_pessoa: 'F' });
              }

              this.setState({
                name: result[0].name,
                nick_name: result[0].nick_name,
                registrationNumber: result[0].registrationNumber,
                fone: result[0].fone,
                fones: JSON.parse(result[0].phoneNumbers || '[]') || [],
                managementPhoneNumbers: JSON.parse(result[0].managementPhoneNumbers || '[]') || [],
                email: result[0].email,
                contatc_name: result[0].contatc_name,
                cep: result[0].cep || '',
                uf: result[0].uf || '',
                localidade: result[0].localidade || '',
                bairro: result[0].bairro || '',
                logradouro: result[0].logradouro || '',
                numero: result[0].numero || '',
                complemento: result[0].complemento || '',
                country: result[0].country || 'Brasil',
                timezone: result[0].timezone || 'America/Sao_Paulo',
                obs: result[0].obs || '',
                image: result[0].image,
                method: result[0].callback ? result[0].callback.method : this.state.method,
                url: result[0].callback ? result[0].callback.url : this.state.url,
                header_tag: result[0].callback ? result[0].callback.header_tag : this.state.header_tag,
                key_value: result[0].callback ? result[0].callback.key_value : this.state.key_value,
                dailySummary: result[0].dailySummary === true || result[0].dailySummary === 1 || result[0].dailySummary === '1' || result[0].dailySummary === 'true',
                openModules: result[0].openModules === true || result[0].openModules === 1 || result[0].openModules === '1' || result[0].openModules === 'true',
                realTime3D: result[0].realTime3D === true || result[0].realTime3D === 1 || result[0].realTime3D === '1' || result[0].realTime3D === 'true',
                realTime3DJobStartAlert:
                  (result[0].realTime3D === true || result[0].realTime3D === 1 || result[0].realTime3D === '1' || result[0].realTime3D === 'true') &&
                  (result[0].realTime3DJobStartAlert === undefined || result[0].realTime3DJobStartAlert === null
                    ? true
                    : (result[0].realTime3DJobStartAlert === true || result[0].realTime3DJobStartAlert === 1 || result[0].realTime3DJobStartAlert === '1' || result[0].realTime3DJobStartAlert === 'true')),
                speed_unit: result[0].speed_unit || '',
                volume_unit: result[0].volume_unit || '',
                length_unit: result[0].length_unit || '',
                area_unit: result[0].area_unit || '',
              });
              this.loadLimit();
            }
          },
          (error) => {
            if (error.status === 405) {
              notification.open({
                message: "PERMISSAO",
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: "ERRO",
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
  };

  loadImage = file => {
    if (file.target.files.length > 0) {
      let filePath = file.target.files[0];

      const fileReader = new FileReader();

      fileReader.onloadend = () => {
        this.setState({
          image: fileReader.result,
          imagehaschanged: true
        });
      };

      fileReader.readAsDataURL(filePath);
    }
  };

  loadLimit() {
    if (this.state.id) {
      const apiUrl = Config.server + '/company_config_id/' + this.state.id;

      const options = {
        method: 'GET',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt')
        }
      }

      fetch(apiUrl, options)
        .then((res) => {
          if (res.status !== 200) throw res;
          else return res.json();
        })
        .then(
          (result) => {
            if (result.length > 0) {
              let temp = {
                limit_orc_ha: result[0].limit_orc_ha ? result[0].limit_orc_ha : 0,
                limit_apr_ha: result[0].limit_apr_ha ? result[0].limit_apr_ha : 0,
                limit_play_ha: result[0].limit_play_ha ? result[0].limit_play_ha : 0,
                limit_json_ha: result[0].limit_json_ha ? result[0].limit_json_ha : 0,
                limit_kmz_ha: result[0].limit_kmz_ha ? result[0].limit_kmz_ha : 0,
                limit_als_ha: result[0].limit_als_ha ? result[0].limit_als_ha : 0,
                limit_clima_api: result[0].limit_clima_api ? result[0].limit_clima_api : 0,
                storage_size: result[0].storage_size ? result[0].storage_size / 1024 / 1024 : 0,
              };

              this.setState(temp);
            }
          },
          (error) => {
            if (error.status === 405) {
              notification.open({
                message: "PERMISSAO",
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            } else if (error.status === 401 || error.status === 403) {
              this.props.link('/login');
            }
            else {
              console.log(error);
              notification.open({
                message: "ERRO",
                icon: <MaterialIcon icon="error" className="text-danger" />
              });
            }
          }
        );
    }
  };

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleCEP = event => {
    const limit = 8;
    const cep = event.target.value.slice(0, limit);

    this.setState({
      cep: cep,
    });

    if (cep.length < 8) {
      return;
    }

    const apiUrl = `${Config.server}/cep/${cep}`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            uf: result.uf || '',
            localidade: result.localidade || '',
            bairro: result.bairro || '',
            logradouro: result.logradouro || '',
            country: 'Brasil'
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      )

  };

  handleSubmit = (event) => {
    event.preventDefault();
    let apiUrl = '';
    let method = '';
    apiUrl = Config.server + '/company/';//TODO: arrumar!!!

    const formData = new URLSearchParams();
    if (this.state.id) {
      apiUrl += this.state.id;
      formData.append('id', this.state.id);
      method = 'PUT';

      formData.append('method', this.state.method);
      formData.append('url', this.state.url);
      formData.append('header_tag', this.state.header_tag);
      formData.append('key_value', this.state.key_value);
    } else {
      method = 'POST';
    }

    if (this.state.tipo_pessoa === 'J') {
      formData.append('cnpj', this.state.cnpj);
    } else {
      formData.append('cnpj', this.state.cpf);
    }
    formData.append('name', this.state.name);
    formData.append('nick_name', this.state.nick_name);
    formData.append('registrationNumber', this.state.registrationNumber);
    formData.append('fone', this.state.fone);
    formData.append('phoneNumbers', JSON.stringify(this.state.fones));
    formData.append('managementPhoneNumbers', JSON.stringify(this.state.managementPhoneNumbers));
    formData.append('email', this.state.email);
    formData.append('contatc_name', this.state.contatc_name);
    formData.append('cep', this.state.cep);
    formData.append('uf', this.state.uf);
    formData.append('localidade', this.state.localidade);
    formData.append('bairro', this.state.bairro);
    formData.append('logradouro', this.state.logradouro);
    formData.append('numero', this.state.numero);
    formData.append('complemento', this.state.complemento);
    formData.append('country', this.state.country);
    formData.append('timezone', this.state.timezone);
    formData.append('obs', this.state.obs);
    formData.append('dailySummary', this.state.dailySummary ? '1' : '0');
    formData.append('openModules', this.state.openModules ? '1' : '0');
    formData.append('realTime3D', this.state.realTime3D ? '1' : '0');
    formData.append('realTime3DJobStartAlert', (this.state.realTime3D && this.state.realTime3DJobStartAlert) ? '1' : '0');
    formData.append('speed_unit', this.state.speed_unit);
    formData.append('volume_unit', this.state.volume_unit);
    formData.append('length_unit', this.state.length_unit);
    formData.append('area_unit', this.state.area_unit);

    if (this.state.imagehaschanged) {
      formData.append('image', this.state.image);
    }

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          if (result != null && result.errno) {
            console.log("Error: ", result);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });

            return;
          }
          let msg = 'O item foi incluido';
          if (this.state.id) {
            msg = 'O item foi alterado';
          }
          notification.open({
            message: 'Successo',
            description: msg,
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          Units.setStored({
            speed_unit: this.state.speed_unit,
            volume_unit: this.state.volume_unit,
            length_unit: this.state.length_unit,
            area_unit: this.state.area_unit
          });
          if (!this.state.id) {
            this.setState({
              cnpj: '',
              cpf: '',
              tipo_pessoa: 'J',
              name: '',
              nick_name: '',
              registrationNumber: '',
              fone: '',
              email: '',
              contatc_name: '',
              adress: '',
              cep: '',
              speed_unit: '',
              volume_unit: '',
              length_unit: '',
              area_unit: '',
              country: 'Brasil',
              timezone: 'America/Sao_Paulo',
            });
          }
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  addLimit = () => {
    let apiUrl = Config.server + '/company_limit';
    let method = 'POST';

    const formData = new URLSearchParams();

    formData.append('id', this.state.id);
    formData.append('type', this.state.type);
    let value = isNaN(this.state.limit) ? 0 : Number(this.state.limit);
    formData.append('value', value);

    let options = {
      method: method,
      body: formData,
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.listLimit();
          let temp = {
            limit_orc_ha: result.limit_orc_ha ? result.limit_orc_ha : 0,
            limit_apr_ha: result.limit_apr_ha ? result.limit_apr_ha : 0,
            limit_als_ha: result.limit_als_ha ? result.limit_als_ha : 0,
            limit_play_ha: result.limit_play_ha ? result.limit_play_ha : 0,
            limit_json_ha: result.limit_json_ha ? result.limit_json_ha : 0,
            limit_kmz_ha: result.limit_kmz_ha ? result.limit_kmz_ha : 0,
            limit_clima_api: result.limit_clima_api ? result.limit_clima_api : 0,
            limit: '0',
          };
          this.setState(temp);
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            console.log(error);
            this.props.link('/login');
          }
          else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  listLimit(openTask, type) {
    this.setState({
      openTask,
      type
    });

    const apiUrl = Config.server + '/company_limit_id/' + this.state.id + '/' + type;//TODO: arrumar!!!

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            itensTask: result,
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: "Permissão Negada",
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: "Erro Inesperado",
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  clickItem = (valor) => {
    this.setState({ limit: valor });
  };

  maskedCPFCNPJ = (props) => {
    const { inputRef, ...other } = props;
    if (this.state.tipo_pessoa === "F") {
      return (
        <MaskedInput
          {...other}
          ref={(ref) => {
            inputRef(ref ? ref.inputElement : null);
          }}
          mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
          placeholderChar={'\u2000'}
          showMask
        />
      );
    } else {
      return (
        <MaskedInput
          {...other}
          ref={(ref) => {
            inputRef(ref ? ref.inputElement : null);
          }}
          mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
          placeholderChar={'\u2000'}
          showMask
        />
      );
    }
  };

  setCrop = (e) => {

  };

  addPhoneField = () => {
    this.setState(prevState => ({
      fones: [...prevState.fones, '']
    }));
  };

  removePhoneField = (index) => {
    if (this.state.fones.length > 1) {
      this.setState(prevState => {
        const removedPhone = prevState.fones[index];
        const fones = prevState.fones.filter((_, i) => i !== index);

        return {
          fones,
          fone: fones[0] || '',
          managementPhoneNumbers: prevState.managementPhoneNumbers.filter(phone => phone !== removedPhone)
        };
      });
    }
  };

  handlePhoneChange = (index, event) => {
    const phone = event.target.value;

    this.setState(prevState => {
      const oldPhone = prevState.fones[index];
      const fones = [...prevState.fones];
      const wasManagementPhone = prevState.managementPhoneNumbers.includes(oldPhone);
      let managementPhoneNumbers = prevState.managementPhoneNumbers;

      fones[index] = phone;

      if (wasManagementPhone) {
        managementPhoneNumbers = phone.trim()
          ? prevState.managementPhoneNumbers.map(item => item === oldPhone ? phone : item)
          : prevState.managementPhoneNumbers.filter(item => item !== oldPhone);
      }

      return {
        fones,
        fone: fones[0] || '',
        managementPhoneNumbers
      };
    });
  };

  handleManagementPhoneChange = (phone, checked) => {
    if (!phone || !phone.trim()) {
      return;
    }

    this.setState(prevState => ({
      managementPhoneNumbers: checked
        ? [...new Set([...prevState.managementPhoneNumbers, phone])]
        : prevState.managementPhoneNumbers.filter(item => item !== phone)
    }));
  };

  render() {
    const { classes, link, res } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <Dialog onClose={event => this.setState({ openTask: false })} aria-labelledby="simple-dialog-title" open={this.state.openTask}>
          <DialogTitle id="simple-dialog-title">Limites</DialogTitle>
          <div style={{ padding: '1rem', width: '25rem' }}>
            <div>
              <TextField
                id="limit"
                label="Limite adicional (ha)"
                value={this.state.limit}
                onChange={this.handleChange('limit')}
                type="number"
                className="mb-4 notTooClose"
                size="small"
                margin="dense"
                style={{ maxWidth: '10rem', width: '100%' }}
                onKeyDown={e => {
                  if (e.keyCode === 13) { this.addLimit() }
                }}
              />
              <Button type="submit" variant="contained" color="primary" className="popUpButton" style={{ marginTop: '1rem', marginLeft: '.5rem' }} onClick={this.addLimit}>
                Adicionar
              </Button>
            </div>
            <List>
              {this.state.itensTask.map((task, key) => (
                <ListItem button onClick={(event) => { this.clickItem(task.value) }}>
                  <div style={{ marginRight: 'auto', width: '6rem' }}>{task.value > 0 ? '+' + task.value : task.value}</div><div style={{ width: '8rem' }}>{tools.formatDateTime(new Date(task.created))}</div><div style={{ marginLeft: '1rem', width: '10rem' }}>{task.name}</div>
                </ListItem>
              ))}
            </List>
          </div>
        </Dialog>
        <div className="containerTop">
          <div><h1>{res.EMPRESA}</h1></div>
          <div className="centerTop"></div>
          <div>
            <Button variant="contained" onClick={evemt => { link('back') }} className="popUpButton">
              {res.CANCELAR}
            </Button> &nbsp;
            <Button type="submit" variant="contained" color="primary" className="popUpButton">
              <SaveIcon className="iconMapS" />
              {res.SALVAR}
            </Button>
          </div>
        </div>
        <div className="form-group notTooBig">
          <FormControl
            style={{ padding: ".4rem 0 .4rem 0" }}
            className={classes.textField}
            fullWidth
            component="fieldset">
            <div className='titleTextRel'>{res.PESSOA}</div>
            <RadioGroup row id="tipo_pessoa" aria-label="pessoa" name="pessoa1" value={this.state.tipo_pessoa} onChange={this.handleChange('tipo_pessoa')}>
              <FormControlLabel value="F" control={<Radio color="primary" />} label={res.FISICA} />
              <FormControlLabel value="J" control={<Radio color="primary" />} label={res.JURIDICA} />
            </RadioGroup>
          </FormControl>
          <FormControl
            fullWidth
            className={classes.textField}>
            <InputLabel htmlFor="formatted-text-mask-input">{res.CPFCNPJ}</InputLabel>
            <Input
              value={(this.state.tipo_pessoa === 'F' ? this.state.cpf : this.state.cnpj) || ' '}
              onChange={this.handleChange((this.state.tipo_pessoa === 'F' ? 'cpf' : 'cnpj'))}
              onFocus={(event) => { event.target.select() }}
              name="textmask"
              id="formatted-text-mask-input"
              inputComponent={this.maskedCPFCNPJ}
            />
          </FormControl>
          <TextField
            required
            id="name"
            label="Razão social"
            className={classes.textField}
            value={this.state.name}
            onChange={this.handleChange('name')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="nick_name"
            label="Nome fantasia"
            className={classes.textField}
            value={this.state.nick_name}
            onChange={this.handleChange('nick_name')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <FormControl
            className={classes.textField}
            fullWidth>

            <img src={this.state.image} width={200} height={200} alt="Logo" />
            <label htmlFor="contained-button-file" style={{ display: 'inline', textAlign: 'left', marginTop: '1rem', marginBottom: '1rem' }}>
              <input
                accept=".jpg, .bmp, .png"
                style={{ display: 'none' }}
                id="contained-button-file"
                type="file"
                onChange={this.loadImage}
              />
              <label htmlFor="contained-button-file">

                <Button component="span" variant="contained" color="primary" className="popUpButton" title={this.props.res.IMPORTAR_KMZ}>
                  <MaterialIcon icon="attach_file" className="iconMap" />
                  Carregar Imagem
                </Button>
              </label>
            </label>
          </FormControl>
          <div className={classes.textField} style={{ textAlign: 'left' }}>
            <TextField
              id="limit_orc_ha"
              label="Limite de orçamento restante (ha)"
              value={this.state.limit_orc_ha}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'O'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="limit_apr_ha"
              label="Limite de avaliação restante (ha)"
              value={this.state.limit_apr_ha}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'A'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="limit_als_ha"
              label="Limite de qualidade restante (ha)"
              value={this.state.limit_als_ha}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'Q'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="limit_play_ha"
              label="Limite de visualização restante (ha)"
              value={this.state.limit_play_ha}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'P'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="limit_json_ha"
              label="Limite de traducao restante (ha)"
              value={this.state.limit_json_ha}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'J'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="limit_kmz_ha"
              label="Limite de KMZ restante (ha)"
              value={this.state.limit_kmz_ha}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'K'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="limit_clima_api"
              label="Limite diario de chamada de API/Clima"
              value={this.state.limit_clima_api}
              type="number"
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />
            <div style={{ display: 'inline-block', marginTop: '1rem', marginLeft: '0.5rem' }}>
              <Button className={this.state.edit_speed ? "buttonS buttonMenuHL" : "buttonS buttonMenu"} onClick={(event) => { this.listLimit(true, 'C'); }} disabled={this.state.id ? '' : 'disabled'}>
                <MaterialIcon icon="settings" className="iconMap" />
              </Button>
            </div>
            <TextField
              id="storage_size"
              label="Total em arquivos"
              value={`${this.state.storage_size.toFixed(1)} MB`}
              className="mb-4 notTooClose"
              size="small"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
              InputProps={{
                readOnly: true,
              }}
            />

            <FormControl
              className="mb-4 notTooClose"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
            >
              <InputLabel shrink htmlFor="speed_unit">{res.UNIDADE_VELOCIDADE}</InputLabel>
              <Select
                id="speed_unit"
                value={this.state.speed_unit}
                onChange={this.handleChange('speed_unit')}
                displayEmpty
                required
              >
                <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                <MenuItem value="km/h">{res.KM_H} (km/h)</MenuItem>
                <MenuItem value="mph">{res.MILHAS_POR_HORA} (mph)</MenuItem>
                <MenuItem value="kt">{res.NOS} (kt)</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              className="mb-4 notTooClose"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
            >
              <InputLabel shrink htmlFor="volume_unit">{res.UNIDADE_VOLUME}</InputLabel>
              <Select
                id="volume_unit"
                value={this.state.volume_unit}
                onChange={this.handleChange('volume_unit')}
                displayEmpty
                required
              >
                <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                <MenuItem value="L">{res.LITROS} (L)</MenuItem>
                <MenuItem value="gal(US)">{res.GALAO_US} (gal(US))</MenuItem>
                <MenuItem value="gal(UK)">{res.GALAO_UK} (gal(UK))</MenuItem>
                <MenuItem value="kg">{res.QUILOGRAMA} (kg)</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              className="mb-4 notTooClose"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
            >
              <InputLabel shrink htmlFor="length_unit">{res.UNIDADE_COMPRIMENTO}</InputLabel>
              <Select
                id="length_unit"
                value={this.state.length_unit}
                onChange={this.handleChange('length_unit')}
                displayEmpty
                required
              >
                <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                <MenuItem value="m">{res.METROS} (m)</MenuItem>
                <MenuItem value="ft">{res.PES} (ft)</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              className="mb-4 notTooClose"
              margin="dense"
              style={{ maxWidth: '32rem', width: '100%' }}
            >
              <InputLabel shrink htmlFor="area_unit">{res.UNIDADE_AREA}</InputLabel>
              <Select
                id="area_unit"
                value={this.state.area_unit}
                onChange={this.handleChange('area_unit')}
                displayEmpty
                required
              >
                <MenuItem value="" disabled>{res.SELECIONE}</MenuItem>
                <MenuItem value="ha">{res.HECTARE} (ha)</MenuItem>
                <MenuItem value="ac">{res.ACRE} (ac)</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: '0.5rem', marginBottom: '0.5rem' }}>
            <TextField
              id="fone"
              label={res.TELEFONE}
              value={this.state.fones[0] || ''}
              onChange={(e) => this.handlePhoneChange(0, e)}
              margin="normal"
              fullWidth
              style={{ flex: 1 }}
              onInput={(e) => e.target.value = e.target.value.toString().slice(0, 45)}
              InputLabelProps={{ shrink: this.state.fones[0] ? true : false }}
            />

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
                minWidth: '250px'
              }}
            >
              <div
                style={{
                  width: '36px',
                  height: '36px',
                  marginRight: '10px'
                }}
              />

              <FormControlLabel
                style={{ margin: 0 }}
                control={
                  <Checkbox
                    checked={this.state.managementPhoneNumbers.includes(this.state.fones[0])}
                    onChange={(event) => this.handleManagementPhoneChange(this.state.fones[0], event.target.checked)}
                    color="primary"
                    disabled={!this.state.fones[0] || !this.state.fones[0].trim()}
                  />
                }
                label="Celular de gestão"
              />
            </div>
          </div>

          {this.state.fones.slice(1).map((fone, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '0.5rem',
                marginLeft: '0.5rem'
              }}
            >
              <TextField
                label={`${res.TELEFONE} ${index + 2}`}
                value={fone}
                onChange={(e) => this.handlePhoneChange(index + 1, e)}
                fullWidth
                margin="normal"
                style={{ flex: 1 }}
              />

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: '10px',
                  minWidth: '250px'
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => this.removePhoneField(index + 1)}
                  style={{
                    minWidth: '36px',
                    width: '36px',
                    height: '36px',
                    padding: 0,
                    marginRight: '10px'
                  }}
                  title={res.REMOVER_TELEFONE}
                >
                  <DeleteIcon />
                </Button>

                <FormControlLabel
                  style={{ margin: 0 }}
                  control={
                    <Checkbox
                      checked={this.state.managementPhoneNumbers.includes(fone)}
                      onChange={(event) => this.handleManagementPhoneChange(fone, event.target.checked)}
                      color="primary"
                      disabled={!fone || !fone.trim()}
                    />
                  }
                  label="Celular de gestão"
                />
              </div>
            </div>
          ))}

          <div
            className={classes.textField}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginTop: '10px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={this.addPhoneField}
            >
              Adicionar Telefone
            </Button>

            <FormControlLabel
              style={{ marginTop: '1rem', marginBottom: '0.5rem' }}
              control={
                <Switch
                  checked={this.state.dailySummary}
                  onChange={(event) => this.setState({ dailySummary: event.target.checked })}
                  color="primary"
                />
              }
              label="Receber resumo diário por WhatsApp"
            />

            <FormControlLabel
              style={{ marginBottom: '0.5rem' }}
              control={
                <Switch
                  checked={this.state.openModules}
                  onChange={(event) => this.setState({ openModules: event.target.checked })}
                  color="primary"
                />
              }
              label="Abrir módulos em nova aba"
            />

            <FormControlLabel
              style={{ marginBottom: '0.5rem' }}
              control={
                <Switch
                  checked={this.state.realTime3D}
                  onChange={(event) => this.setState({
                    realTime3D: event.target.checked,
                    realTime3DJobStartAlert: event.target.checked ? this.state.realTime3DJobStartAlert : false
                  })}
                  color="primary"
                />
              }
              label="3D em tempo real"
            />

            <FormControlLabel
              style={{ marginBottom: '0.5rem', marginLeft: '1.5rem' }}
              control={
                <Switch
                  checked={this.state.realTime3DJobStartAlert}
                  onChange={(event) => this.setState({ realTime3DJobStartAlert: event.target.checked })}
                  color="primary"
                  disabled={!this.state.realTime3D}
                />
              }
              label="Receber alerta de início de trabalho"
            />
          </div>

          <TextField
            id="email"
            label="Email"
            className={classes.textField}
            value={this.state.email}
            onChange={this.handleChange('email')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="registrationNumber"
            label="Registro M.A.P.A."
            className={classes.textField}
            value={this.state.registrationNumber}
            onChange={this.handleChange('registrationNumber')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="contatc_name"
            label="Nome do contato"
            className={classes.textField}
            value={this.state.contatc_name}
            onChange={this.handleChange('contatc_name')}
            margin="normal"
            fullWidth
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="country"
            label="País"
            className={classes.textField}
            value={this.state.country}
            onChange={this.handleChange('country')}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 100)
            }}
          />
          <TextField
            select
            id="timezone"
            label="Fuso horário"
            className={classes.textField}
            value={this.state.timezone}
            onChange={this.handleChange('timezone')}
            margin="normal"
          >
            {this.state.timezone && !TIMEZONES.includes(this.state.timezone) &&
              <MenuItem value={this.state.timezone}>{this.state.timezone}</MenuItem>}
            {TIMEZONES.map(timezone => {
              const offset = getTimezoneOffsetLabel(timezone);
              return (
                <MenuItem key={timezone} value={timezone}>
                  {timezone}{offset ? ` (${offset})` : ''}
                </MenuItem>
              );
            })}
          </TextField>
          <TextField
            id="cep"
            label="CEP"
            type='number'
            className={classes.textField}
            value={this.state.cep}
            onChange={this.handleCEP}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="localidade"
            label="Localidade"
            className={classes.textField}
            value={this.state.localidade}
            onChange={this.handleChange('localidade')}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="bairro"
            label="Bairro"
            className={classes.textField}
            value={this.state.bairro}
            onChange={this.handleChange('bairro')}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="logradouro"
            label="Logradouro"
            className={classes.textField}
            value={this.state.logradouro}
            onChange={this.handleChange('logradouro')}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="numero"
            label="Número"
            className={classes.textField}
            value={this.state.numero}
            onChange={this.handleChange('numero')}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            id="complemento"
            label="Complemento"
            className={classes.textField}
            value={this.state.complemento}
            onChange={this.handleChange('complemento')}
            margin="normal"
            onInput={(e) => {
              e.target.value = e.target.value.toString().slice(0, 45)
            }}
          />
          <TextField
            multiline
            fullWidth
            rows={4}
            id="obs"
            label="Observações"
            className={classes.textField}
            value={this.state.obs}
            onChange={this.handleChange('obs')}
            margin="normal"
          />
          {this.state.id && <>
            <h3 style={{ marginTop: '1rem' }}>CallBack</h3>
            <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: '5rem calc(100% - 6rem)' }}>
              <div style={{ botton: 0, }}>
                <FormControl style={{ width: '100%', marginBottom: '1rem' }}>
                  <InputLabel htmlFor="type-service">{'Method'}</InputLabel>
                  <Select native value={this.state.method} onChange={this.handleChange('method')} className={classes.textField}>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                  </Select>
                </FormControl>
              </div>
              <div style={{ marginTop: '-1rem' }}>
                <TextField
                  id="url"
                  label="URL"
                  className={classes.textField}
                  value={this.state.url}
                  onChange={this.handleChange('url')}
                  fullWidth
                  margin="normal"
                  onInput={(e) => {
                    e.target.value = e.target.value.toString().slice(0, 255)
                  }}
                />
              </div>
            </div>
            <div style={{ display: 'grid', gap: '1rem', gridTemplateColumns: '10rem calc(100% - 11rem)' }}>
              <TextField
                id="header_tag"
                label="Header Tag"
                className={classes.textField}
                value={this.state.header_tag}
                onChange={this.handleChange('header_tag')}
                margin="normal"
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 45)
                }}
              />
              <TextField
                id="key_value"
                label="Key Value"
                className={classes.textField}
                value={this.state.key_value}
                onChange={this.handleChange('key_value')}
                margin="normal"
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 45)
                }}
              />
            </div>
          </>}
        </div>
      </form>
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res } = props;
  let { id } = useParams();
  return (
    <div className="rowForm">
      <div className="divContent">
        <TextFields1 link={link} id={id} res={res} />
      </div>
    </div>)
}

export default Box;
